import { SET_CURRENCY } from "../actions/currencyActions";

const initState = {
  currencySymbol: "TL",
  currencyName: "TRY",
  currencyRate: 1
};

const currencyReducer = (state = initState, action) => {
  if (action.type === SET_CURRENCY) {
    const currencyName = action.payload.currencyName;
    if (currencyName === "TRY") {
      return {
        ...state,
        currencySymbol: "TL",
        currencyRate: action.payload.currencyRate,
        currencyName
      };
    }
  }

  return state;
};

export default currencyReducer;
